window.ExplorePage = new function()
{
    this.init = function() {
        $('.trending-communities-slider').slick({
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '20%',
          autoplay: true,
          autoplaySpeed: 5000,
          pauseOnHover: false,
          responsive: [
              {
                breakpoint: 767,
                settings: {
                  centerPadding: '10%',
                }
              }
            ]
        });

        const tags = jQuery('.popular-tags a');
        const totalTags = tags.length;

        if (totalTags <= 8) {
            tags.each(function (index) {
              let opacity = 1.0 - (index * 0.1);
              jQuery(this).css('background-color', `rgba(235, 33, 46, ${opacity})`);
            });
        } else {
            tags.each(function (index) {
              let opacity = 1.0 - (index * (0.7 / (totalTags - 1)));
              opacity = Math.max(opacity, 0.3);
              jQuery(this).css('background-color', `rgba(235, 33, 46, ${opacity})`);
            });
        }

        $('.trending-communities-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
            $('.slide-index .current-slide').text(currentSlide + 1);
        });

        jQuery('select[name="filter_communities"]').change(function(event) {
            var filter = jQuery(this).find('option:selected').val();
            window.location.href = '/explore/communities?filter=' + filter;
        });

        jQuery('select[name="filter_users"]').change(function(event) {
            var filter = jQuery(this).find('option:selected').val();
            window.location.href = '/explore/users?filter=' + filter;
        });

        jQuery('select[name="filter_channels"]').change(function(event) {
            var filter = jQuery(this).find('option:selected').val();
            window.location.href = '/explore/channels?filter=' + filter;
        });

        jQuery('select[name="filter_pages"]').change(function(event) {
            var filter = jQuery(this).find('option:selected').val();
            window.location.href = '/explore/pages?filter=' + filter;
        });

        jQuery('.trending-communities-slider').on('afterChange', function(slick, currentSlide, nextSlide){
            jQuery('.trending-communities-slider .slider-progress .progress').animate({
                width: '+=100%'
            }, 5000, 'linear', function() {
                jQuery('.trending-communities-slider .slider-progress .progress').css('width', '0%');
            }); 
        });

        jQuery('.trending-communities-slider .slider-progress .progress').animate({
            width: '+=100%'
        }, 5000, 'linear', function() {
            jQuery('.trending-communities-slider .slider-progress .progress').css('width', '0%');
        }); 

        jQuery('.trending-communities-slider').on('swipe', function(slick, direction) {
          jQuery('.trending-communities-slider .slider-progress').hide();
        });

        jQuery('body').on('click', '.slick-arrow', function(slick, direction) {
          jQuery('.trending-communities-slider .slider-progress').hide();
        });
    };
}

jQuery(document).ready(function($) {
    ExplorePage.init();
});
